/* ============================================================
   SANTJAKOV — ficha de prenda
   Resuelve color + talla contra las variantes de Shopify y mantiene el
   comportamiento del sitio estático: la talla se elige antes de añadir, y si
   no, el botón se marca con `.needs` y la fila de tallas parpadea con `.flash`.
   Ese aviso no es decorativo: sin él el cliente da a "Add to cart" y no pasa
   nada visible.
   ============================================================ */
(function(){
  const D=document;

  /* Se expone para que el drawer pueda inicializar la ficha que acaba de
     inyectar: es el MISMO markup que la página, así que debe comportarse igual.
     Sin esto, la ficha en capa se vería bien pero los selectores estarían
     muertos. */
  window.montarFicha=montar;

  const enPagina=D.querySelector('.pview--pagina');
  if(enPagina) montar(enPagina);

  function montar(raiz){
  const datos=raiz.querySelector('#datosVariantes')||D.getElementById('datosVariantes');
  if(!datos) return;

  let variantes=[];
  try{ variantes=JSON.parse(datos.textContent); }catch(e){ return; }

  const campoId=raiz.querySelector('input[name="id"]');
  const bColores=[...raiz.querySelectorAll('.d-color-op')];
  const bTallas=[...raiz.querySelectorAll('.sizes button')];
  const filaTallas=raiz.querySelector('.sizes');
  const botonAdd=raiz.querySelector('.d-add');
  const foto=raiz.querySelector('.d-main');
  const precio=raiz.querySelector('.d-pr');
  const etiquetaColor=raiz.querySelector('.d-color');
  const bMinis=[...raiz.querySelectorAll('.d-thumbs button')];

  let color=(bColores.find(b=>b.classList.contains('sel'))||bColores[0])?.dataset.color||null;
  let talla=null;

  const dinero=c=>'$'+(c/100).toLocaleString('en-US',{minimumFractionDigits:0,maximumFractionDigits:2});

  /* Una talla solo existe si hay una variante de ESE color con ESA talla. La
     Zenith es el caso vivo: la S solo se produjo en negro y el gris oscuro no
     llega a XL. Mostrar tallas que no existen sería prometer lo que no hay. */
  function refrescarTallas(){
    bTallas.forEach(b=>{
      const v=variantes.find(x=>x.color===color&&x.talla===b.dataset.size);
      const hay=!!v&&v.disponible;
      b.disabled=!hay;
      b.classList.toggle('agotada',!hay);
      if(!hay&&b.classList.contains('sel')){b.classList.remove('sel');talla=null;}
    });
  }

  /* Cambiar `src` NO basta: la foto grande lleva `srcset` para no bajar 1400 px
     en una pantalla que muestra 500. Mientras ese atributo exista, el navegador
     resuelve la imagen desde ahí e ignora el `src` nuevo — la ficha se quedaba
     con la foto del color anterior aunque el resto de la ficha ya hubiera
     cambiado. Se retira el `srcset` en el primer cambio y a partir de ahí manda
     `src`; la carga inicial, que es la que pesa, sigue aprovechándolo. */
  function ponerFoto(url){
    if(!foto||!url||url==='null') return;
    /* Si ya es ESA foto, no se toca. Al montar la ficha se llama con la foto
       de la variante, que es la misma que ya pintó el servidor pero pedida a
       otro ancho: cambiarla hacía que la imagen se volviera a descargar y la
       página parpadeara como si se recargara. Se compara el archivo, no la
       URL entera, porque el ancho y la versión van en la consulta. */
    const archivo=u=>{ try{ return new URL(u,location.href).pathname; }catch(e){ return u; } };
    if(archivo(foto.currentSrc||foto.src)===archivo(url)) return;
    foto.removeAttribute('srcset');
    foto.removeAttribute('sizes');
    foto.src=url;
  }

  /* Las miniaturas se filtran por el color elegido leyendo el texto alternativo
     de cada foto, el mismo criterio que aplica el Liquid al pintar la ficha. Si
     ninguna imagen nombra colores no se filtra nada: mejor enseñar de más que
     dejar la ficha sin fotos. */
  const etiquetadas = raiz.querySelector('.d-thumbs-etiquetadas');
  const hayEtiquetas = etiquetadas ? etiquetadas.textContent.trim()==='true' : false;

  function filtrarMinis(){
    if(!hayEtiquetas||!color) return null;
    let primera=null;
    bMinis.forEach(b=>{
      const suya=(b.dataset.alt||'').indexOf(color)!==-1;
      b.hidden=!suya;
      b.classList.toggle('oculta',!suya);
      if(suya&&!primera) primera=b;
      if(!suya) b.classList.remove('sel');
    });
    if(primera){
      bMinis.forEach(o=>o.classList.toggle('sel',o===primera));
    }
    return primera;
  }

  function sincronizar(){
    const v=variantes.find(x=>x.color===color&&(talla?x.talla===talla:true));
    if(!v) return;
    if(talla&&campoId) campoId.value=v.id;
    if(precio) precio.textContent=dinero(v.precio);
    if(etiquetaColor) etiquetaColor.textContent=color;
    /* El color elegido queda en la URL (`?variant=`): al recargar, el Liquid
       abre la ficha en ese color y no en el primero (negro). Solo en la
       página; el drawer no tiene URL propia. replaceState no recarga ni mueve
       el scroll. */
    if(raiz===enPagina){
      const enUrl=talla?v:(variantes.find(x=>x.color===color&&x.disponible)||v);
      const u=new URL(location.href);
      if(u.searchParams.get('variant')!==String(enUrl.id)){
        u.searchParams.set('variant',enUrl.id);
        history.replaceState(history.state,'',u);
      }
    }
    const primera=filtrarMinis();
    /* la foto de la variante manda; si no tiene, la primera de su color */
    ponerFoto(v.foto && v.foto!=='null' ? v.foto : (primera&&primera.dataset.img));
  }

  bColores.forEach(b=>b.addEventListener('click',()=>{
    color=b.dataset.color;
    bColores.forEach(o=>{o.classList.toggle('sel',o===b);o.setAttribute('aria-pressed',String(o===b));});
    refrescarTallas(); sincronizar();
  }));

  bTallas.forEach(b=>b.addEventListener('click',()=>{
    if(b.disabled) return;
    talla=b.dataset.size;
    bTallas.forEach(o=>o.classList.toggle('sel',o===b));
    if(botonAdd) botonAdd.classList.remove('needs');
        if(filaTallas){
          filaTallas.classList.remove('falta','flash');
          const rot=filaTallas.previousElementSibling; rot&&rot.classList.remove('falta');
          const msg=filaTallas.parentNode.querySelector('.falta-msg'); msg&&msg.remove();
        }
    sincronizar();
  }));

  /* Las miniaturas cambian la foto grande; no tocan la variante elegida. */
  bMinis.forEach(b=>b.addEventListener('click',()=>{
    ponerFoto(b.dataset.img);
    bMinis.forEach(o=>o.classList.toggle('sel',o===b));
  }));

  const formulario=raiz.querySelector('form');
  formulario&&formulario.addEventListener('submit',ev=>{
    if(!talla){ ev.preventDefault(); marcarFalta(); }
  });

  /* PAGO RÁPIDO: el botón de Shop Pay / Apple Pay compra la variante que tenga
     el campo `id`, que antes de elegir talla es la de por defecto. Sin talla se
     corta el clic en fase de captura (antes de que llegue al botón de Shopify)
     y se marca lo que falta, igual que con "Add to cart". */
  const pago=raiz.querySelector('.d-pago');
  pago&&pago.addEventListener('click',ev=>{
    if(!talla){ ev.preventDefault(); ev.stopImmediatePropagation(); marcarFalta(); }
  },true);
  /* En el drawer la ficha llega por fetch: Shopify solo pinta sus botones al
     cargar la página, así que se le pide que los pinte otra vez. */
  if(raiz!==enPagina&&pago&&window.Shopify&&Shopify.PaymentButton&&Shopify.PaymentButton.init) Shopify.PaymentButton.init();

  function marcarFalta(){
    /* bloque */ {
      if(botonAdd) botonAdd.classList.add('needs');
      /* LO QUE FALTA, EN ROJO (web-pitfalls #22): las tallas y su rótulo se
         marcan, un texto dice qué falta y la página lleva hasta ahí. El rojo se
         queda hasta que se elige talla; no es un parpadeo. */
      if(filaTallas){
        filaTallas.classList.add('falta');
        const rot=filaTallas.previousElementSibling; if(rot&&rot.classList.contains('lbl')) rot.classList.add('falta');
        let msg=filaTallas.parentNode.querySelector('.falta-msg');
        if(!msg){ msg=document.createElement('p'); msg.className='falta-msg'; msg.setAttribute('role','alert'); filaTallas.insertAdjacentElement('afterend',msg); }
        msg.textContent=(botonAdd&&botonAdd.dataset.falta)||'Select a size';
        const r=filaTallas.getBoundingClientRect();
        if(r.top<90||r.bottom>innerHeight-20) filaTallas.scrollIntoView({block:'center',behavior:'smooth'});
      }
    }
  }

  refrescarTallas(); sincronizar();
  }
})();
